<template>
  <v-snackbar v-model="visible" :timeout="8000" :color="color" :multi-line="multiline" bottom right>
    {{ message }}
    <v-btn dark flat icon @click.native="hideGlobalToast()">
      <v-icon>clear</v-icon>
    </v-btn>
  </v-snackbar>
</template>
  <script>
  import {
    mapGetters,
    mapActions,
  } from 'vuex';

  export default {
    parent: true,
    computed: {
      visible: {
        get() {
          return this.showToast;
        },
        set() {
          this.hideGlobalToast();
        },
      },

      ...mapGetters({
        showToast: 'toasts/showToast',
        color: 'toasts/toastColor',
        message: 'toasts/toastMessage',
        multiline: 'toasts/toastMultiLine',
      }),
    },

    methods: {
      ...mapActions({
        hideGlobalToast: 'toasts/hideGlobalToast',
      }),
    },
  };
  </script>